<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 120"
    :width="size"
    :height="size"
    class="icon"
  >
    <slot />
  </svg>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'

export const props = {
  size: {
    type: Number as PropType<12 | 16 | 20 | 24 | 32>,
    default: 16,
  },
}
export default Vue.extend({
  props,
})
</script>

<style scoped>
.icon:deep(path),
.icon:deep(rect),
.icon:deep(circle) {
  @apply fill-current;
}
</style>
